<template>
  <b-row>
    <b-col sm="12">
      <b-card>

        <b-row class="pt-sm-2">
          <b-col sm="1">
            <span class="card-title wise-card-title">검색 조건</span>
          </b-col>
          <b-col sm="1"><strong>카테고리</strong></b-col>
          <b-col sm="5" style="display: inline-flex;">
            <b-form-radio-group id="report_cate" v-model="queryParams.product_type_code" :options="product_type_option" name="report_cate"/>
          </b-col>
        </b-row>


        <!-- 기간설정 START -->
        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>등록일</strong></b-col>
          <b-col sm="3">
            <date-picker v-model="fullDateTmp"
                         type="date"
                         style="width: 100%;"
                         range
                         placeholder="조회기간 선택"
                         :lang="datepickerLang"
                         @change="handleDateRangeChange"/>
          </b-col>
          <b-col sm="6">
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('ALL')">전체</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1WEEK')">1주일</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1MONTH')">1개월</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('6MONTH')">6개월</button>
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('1YEAR')">1년</button>
          </b-col>
        </b-row>
        <!-- 기간설정 END -->

        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>조회구분</strong></b-col>
          <b-col sm="4" style="display: inline-flex;">
            <b-form-radio-group id="order_type" v-model="queryParams.view_type" :options="view_type_option" name="order_type"/>
          </b-col>
        </b-row>


        <b-row class="pt-sm-1">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>검색어</strong></b-col>
          <b-col sm="8">
            <b-form-input v-model="queryParams.keyword" placeholder=""
                          v-on:keyup="$event.keyCode === 13 ? findContentStatisticsList() : ''"/>
          </b-col>
          <b-col sm="2" style="text-align: center;">
            <b-button variant="primary" style="width: 100%;" v-on:click="findContentStatisticsList()">검색</b-button>
          </b-col>
        </b-row>

      </b-card>
    </b-col>
  </b-row>
</template>
<script>

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import _ from 'lodash'
import { EventBus } from "../../../../event-bus";

export default {
  name: 'ArSearch',
  props: {
    queryParams: {
      type: Object
    },
    fullDate: {
      type: Array,
    },
  },
  components: {
    DatePicker
  },
  data () {
    return {
      datepickerLang: {
        yearFormat: "YYYY년",
        monthFormat: "M월",
        days:["일","월","화","수","목","금","토"]
      },
      product_type_option: [
        {text: '전체', value: 'all'},
        {text: '종합보고서', value: 'PRDT_TYPE_1_1'},
        {text: '이벤트패키지', value: 'PRDT_TYPE_1_2'},
      ],

      view_type_option: [
        {text: '조회순', value: 'VIEW'},
        {text: '추천순', value: 'RECOMMAND'},
        {text: '다운로드순', value: 'DOWNLOAD'},
        {text: '후속연구요청순', value: 'RESEARCH'},
      ],
      active_ynsoptions: [{text: '전체', value: 'all'}, {text: '활성', value: 'Y'}, {text: '비활성', value: 'N'}],
      fullDateTmp: [],
    }
  },
  mounted() {
  },
  methods: {

    findContentStatisticsList() {
      //this.queryParams.keyword = this.queryParams.keyword.replace(/\s/g, '');
      EventBus.$emit('callFindContent');
    },

    handleDateRangeChange() {
      this.$parent.fullDate = this.fullDateTmp;
      console.log('handleDateRangeChange >>>>', this.$parent.fullDate);
    },

    // 날짜 정의
    dateRange(flag) {
      let endDate;
      let startDate;
      if(this.fullDateTmp.length === 0){
        endDate = new Date();
        startDate = new Date();
      }else{
        endDate = this.fullDateTmp[1];
        startDate = _.clone(this.fullDateTmp[1]);
      }

      if(flag == '1WEEK'){
        startDate.setDate(endDate.getDate() - 7);
      }else if(flag == '1MONTH'){
        startDate.setMonth(endDate.getMonth() - 1);
      }else if(flag == '6MONTH'){
        startDate.setMonth(endDate.getMonth() - 6);
      }else if(flag == '1YEAR'){
        startDate.setFullYear(endDate.getFullYear() - 1);
      }
      this.fullDateTmp = [startDate, endDate];
      if(flag == 'ALL'){
        this.fullDateTmp = [];
      }
      this.handleDateRangeChange();
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/statistics/content/component/ArStatistics/ArSearch.vue